import {
  CustomTheme,
  masmovilPalette,
  llamayaPalette,
  greyMultibrandPalette,
} from '@masfront/common-b2c'

import { makeStyles, createStyles } from '@material-ui/core'

import { CustomerSector } from '../../model/customer.model'

import { Brand, getBrandFromThemeName } from '~/brand'
import { deepMerge } from '~/utils'

const commonStyles = {
  root: {},
}

interface SegmentSignProps {
  type: CustomerSector
}
const styles = {
  [Brand.llamaya]: deepMerge(commonStyles, {
    root: {
      backgroundColor: (props: SegmentSignProps) => {
        switch (props.type) {
          case CustomerSector.RESIDENTIAL:
            return llamayaPalette.green[500]
          case CustomerSector.SELF_EMPLOYED:
            return llamayaPalette.violet[300]
          case CustomerSector.COMPANY:
          case CustomerSector.HORECA:
            return llamayaPalette.blue[800]
          case CustomerSector.UNKNOWN:
          default:
            return greyMultibrandPalette[500]
        }
      },
    },
  }),
  [Brand.masmovil]: deepMerge(commonStyles, {
    root: {
      backgroundColor: (props: SegmentSignProps) => {
        switch (props.type) {
          case CustomerSector.RESIDENTIAL:
            return masmovilPalette.green[550]
          case CustomerSector.SELF_EMPLOYED:
            return masmovilPalette.violet[300]
          case CustomerSector.COMPANY:
          case CustomerSector.HORECA:
            return masmovilPalette.blue[800]
          case CustomerSector.UNKNOWN:
          default:
            return greyMultibrandPalette[500]
        }
      },
    },
  }),
}

const useBrandStyles = makeStyles((theme: CustomTheme) => {
  const stylesRules = styles[getBrandFromThemeName(theme.name)]
  return createStyles(stylesRules)
})

export default useBrandStyles
